import React, {useEffect, useState} from 'react';
import "../../sass/main.scss";
import CmnCard from "../CmnCard";
import $ from "jquery";
import {useHistory} from "react-router-dom";
import Fn from "../../libraries/Fn";
import axios2 from "../../helpers/APIHelper";
import JDatePicker from "../common/JDatePicker";
import TopScroller from "../common/TopScroller";

// 스크립트 없음
const AnalysisSubsStat4 = (props) => {

  window._load = (_page = 1) => {
    try {
      load(_page);
    } catch (e) {
    }
  }
  const history = useHistory();

  const [result, setResult] = useState({});
  const [renew, setRenew] = useState(0);
  // 로딩 상태를 관리할 state 추가
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    $('#s_date1').val(Fn.getCurrentDate());
    $('#s_date2').val(Fn.getCurrentDate());
  }, []);

  useEffect(() => {
    load();
  }, [renew]);

  // 로딩 스피너와 배경 딤 처리를 위한 CSS 스타일
  const spinnerStyles = {
    loadingOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)', // 배경 약간 어둡게
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999, // 다른 요소들 위에 표시
      flexDirection: 'column'
    },
    spinner: {
      border: '5px solid #f3f3f3',
      borderTop: '5px solid #3498db',
      borderRadius: '50%',
      width: '50px',
      height: '50px',
      animation: 'spin 1s linear infinite',
    },
    loadingText: {
      color: 'white',
      marginTop: '15px',
      fontSize: '16px',
      fontWeight: 'bold'
    }
  };

  // keyframes 애니메이션을 위한 스타일 태그 추가
  useEffect(() => {
    const styleTag = document.createElement('style');
    styleTag.innerHTML = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(styleTag);

    return () => {
      document.head.removeChild(styleTag);
    };
  }, []);

  const load = () => {
    $("#overlay").detach();
    // 로딩 시작 시 스피너 표시
    setIsLoading(true);

    axios2
      .post(`/subscription/stat4/ready?srchDtS=${$('#s_date1').val() || ''}&srchDtE=${$('#s_date2').val() || ''}`)
      .then((response) => {
        console.log(response);
        const {code, message, result: _result, pageInfo} = response?.data;
        if (code === 200) {
          setResult(_result);
        }
      })
      .catch((error) => {
        if (!window.disableErrorMsg) alert('데이터오류! 시스템 관리자에게 문의하세요');
      })
      .finally(() => {
        // 로딩 종료 시 스피너 숨김 (성공/실패 모두)
        setIsLoading(false);
        $("#overlay").attach();
      });
  }

  return (
    <CmnCard onLogout={props.onLogout}>
      {/* 로딩 스피너 및 딤 처리 */}
      {isLoading && (
        <div style={spinnerStyles.loadingOverlay}>
          <div style={spinnerStyles.spinner}></div>
          <div style={spinnerStyles.loadingText}>데이터를 불러오는 중입니다</div>
        </div>
      )}

      <div className="m-3" style={{clear: 'both'}}>
        <div className="tabs">
          <input id="aa" type="radio" name="tab_item" onClick={() => history.push("/analysis/subs/stat1")}/>
          <label className="tab_item" htmlFor="aa">매출</label>

          <input id="bb" type="radio" name="tab_item" onClick={() => history.push("/analysis/subs/stat2")}/>
          <label className="tab_item" htmlFor="bb">지속성</label>

          <input id="cc" type="radio" name="tab_item" onClick={() => history.push("/analysis/subs/stat3")}/>
          <label className="tab_item" htmlFor="cc">쿠폰</label>

          <input id="dd" type="radio" name="tab_item" checked onClick={() => history.push("/analysis/subs/stat4")}/>
          <label className="tab_item" htmlFor="dd">성별/나이대</label>
        </div>
      </div>

      <div className="overflowX ">
        <div className="d-flex m-3 table_wide_sh2">
          <div className="input-group" style={{width: 'auto'}}>
            <JDatePicker className="form-control" aria-describedby="button-addon2" id="s_date1"/>
            <p className="mx-2">~</p>
            <JDatePicker className="form-control" aria-describedby="button-addon2" id="s_date2"/>
          </div>

          <div className="pr-1">
            <button type="button" className="btn btn-sm btn-point px-3" onClick={() => setRenew(Fn.getRenewTime())}>검색</button>
          </div>
        </div>

        <div className="m-3 pb-2 table_list table_wide_sh2">
          <table className="view-rounded sub_table_border">
            <>
              <colgroup>
                <col width="*"/>
                <col width="*"/>
                <col width="*"/>
                <col width="*"/>
                <col width="*"/>
                <col width="*"/>
                <col width="*"/>
                <col width="*"/>
                <col width="*"/>
              </colgroup>
              <tr>
                <th>지점</th>
                <th>남성</th>
                <th>여성</th>
                <th>10대</th>
                <th>20대</th>
                <th>30대</th>
                <th>40대</th>
                <th>50대</th>
                <th>60대+</th>
              </tr>
            </>
            {(() => {
              // result?.items가 없으면 빈 배열 반환
              if (!result?.items || result.items.length === 0) {
                return [];
              }

              // 전체 합계 계산 (모든 지점의 합)
              const 전체남성합계 = result.items.reduce((sum, row) => sum + (parseInt(row?.남성) || 0), 0);
              const 전체여성합계 = result.items.reduce((sum, row) => sum + (parseInt(row?.여성) || 0), 0);
              const 전체a10합계 = result.items.reduce((sum, row) => sum + (parseInt(row?.a10) || 0), 0);
              const 전체a20합계 = result.items.reduce((sum, row) => sum + (parseInt(row?.a20) || 0), 0);
              const 전체a30합계 = result.items.reduce((sum, row) => sum + (parseInt(row?.a30) || 0), 0);
              const 전체a40합계 = result.items.reduce((sum, row) => sum + (parseInt(row?.a40) || 0), 0);
              const 전체a50합계 = result.items.reduce((sum, row) => sum + (parseInt(row?.a50) || 0), 0);
              const 전체a60합계 = result.items.reduce((sum, row) => sum + (parseInt(row?.a60) || 0), 0);

              // 전체 합계에 대한 비율 계산
              const 전체성별합계 = 전체남성합계 + 전체여성합계;
              const 전체남성비율 = 전체성별합계 > 0 ? ((전체남성합계 / 전체성별합계) * 100).toFixed(1) : 0;
              const 전체여성비율 = 전체성별합계 > 0 ? ((전체여성합계 / 전체성별합계) * 100).toFixed(1) : 0;

              const 전체연령합계 = 전체a10합계 + 전체a20합계 + 전체a30합계 + 전체a40합계 + 전체a50합계 + 전체a60합계;
              const 전체a10비율 = 전체연령합계 > 0 ? ((전체a10합계 / 전체연령합계) * 100).toFixed(1) : 0;
              const 전체a20비율 = 전체연령합계 > 0 ? ((전체a20합계 / 전체연령합계) * 100).toFixed(1) : 0;
              const 전체a30비율 = 전체연령합계 > 0 ? ((전체a30합계 / 전체연령합계) * 100).toFixed(1) : 0;
              const 전체a40비율 = 전체연령합계 > 0 ? ((전체a40합계 / 전체연령합계) * 100).toFixed(1) : 0;
              const 전체a50비율 = 전체연령합계 > 0 ? ((전체a50합계 / 전체연령합계) * 100).toFixed(1) : 0;
              const 전체a60비율 = 전체연령합계 > 0 ? ((전체a60합계 / 전체연령합계) * 100).toFixed(1) : 0;

              // 각 지점의 행 생성 (map이 아닌 배열을 명시적으로 생성)
              const rows = [];

              // 각 지점의 행 추가
              result.items.forEach((row, index) => {
                // 성별 합계 및 비율 계산
                const 성별합계 = (parseInt(row?.남성) || 0) + (parseInt(row?.여성) || 0);
                const 남성비율 = 성별합계 > 0 ? ((parseInt(row?.남성) / 성별합계) * 100).toFixed(1) : 0;
                const 여성비율 = 성별합계 > 0 ? ((parseInt(row?.여성) / 성별합계) * 100).toFixed(1) : 0;

                // 연령대 합계 및 비율 계산
                const 연령대합계 = (parseInt(row?.a10) || 0) + (parseInt(row?.a20) || 0) + (parseInt(row?.a30) || 0) +
                  (parseInt(row?.a40) || 0) + (parseInt(row?.a50) || 0) + (parseInt(row?.a60) || 0);
                const a10비율 = 연령대합계 > 0 ? ((parseInt(row?.a10) / 연령대합계) * 100).toFixed(1) : 0;
                const a20비율 = 연령대합계 > 0 ? ((parseInt(row?.a20) / 연령대합계) * 100).toFixed(1) : 0;
                const a30비율 = 연령대합계 > 0 ? ((parseInt(row?.a30) / 연령대합계) * 100).toFixed(1) : 0;
                const a40비율 = 연령대합계 > 0 ? ((parseInt(row?.a40) / 연령대합계) * 100).toFixed(1) : 0;
                const a50비율 = 연령대합계 > 0 ? ((parseInt(row?.a50) / 연령대합계) * 100).toFixed(1) : 0;
                const a60비율 = 연령대합계 > 0 ? ((parseInt(row?.a60) / 연령대합계) * 100).toFixed(1) : 0;

                rows.push(
                  <tr key={`row-${index}`}>
                    <td>{row?.branch_name}</td>
                    <td>{Fn.numberWithCommas(row?.남성)} ({남성비율}%)</td>
                    <td>{Fn.numberWithCommas(row?.여성)} ({여성비율}%)</td>
                    <td>{Fn.numberWithCommas(row?.a10)} ({a10비율}%)</td>
                    <td>{Fn.numberWithCommas(row?.a20)} ({a20비율}%)</td>
                    <td>{Fn.numberWithCommas(row?.a30)} ({a30비율}%)</td>
                    <td>{Fn.numberWithCommas(row?.a40)} ({a40비율}%)</td>
                    <td>{Fn.numberWithCommas(row?.a50)} ({a50비율}%)</td>
                    <td>{Fn.numberWithCommas(row?.a60)} ({a60비율}%)</td>
                  </tr>
                );
              });

              // 총합 행 추가
              rows.push(
                <tr key="total" className="total-row" style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                  <td>총합</td>
                  <td>{Fn.numberWithCommas(전체남성합계)} ({전체남성비율}%)</td>
                  <td>{Fn.numberWithCommas(전체여성합계)} ({전체여성비율}%)</td>
                  <td>{Fn.numberWithCommas(전체a10합계)} ({전체a10비율}%)</td>
                  <td>{Fn.numberWithCommas(전체a20합계)} ({전체a20비율}%)</td>
                  <td>{Fn.numberWithCommas(전체a30합계)} ({전체a30비율}%)</td>
                  <td>{Fn.numberWithCommas(전체a40합계)} ({전체a40비율}%)</td>
                  <td>{Fn.numberWithCommas(전체a50합계)} ({전체a50비율}%)</td>
                  <td>{Fn.numberWithCommas(전체a60합계)} ({전체a60비율}%)</td>
                </tr>
              );

              return rows;
            })()}
          </table>
        </div>
      </div>
      <TopScroller/>
    </CmnCard>
  );
};

export default AnalysisSubsStat4;
